import LandingPage, { type LandingPageContent } from '../LandingPage';

const content: LandingPageContent = {
  eyebrow: 'Home Transition During Health Changes',
  headline: 'Your Home Should Support Your Life — Not Complicate It.',
  subhead:
    'When health changes shift your priorities, the house that once felt like home can start to feel like a burden. There\'s a way through this that protects your dignity and your equity.',
  truth:
    'No one prepares you for the moment your home stops working for you.\n\nMaybe the stairs aren\'t safe anymore. Maybe the maintenance is too much. Maybe you\'re supporting a parent through a transition they never planned for.\n\nThe emotional weight of selling a home you\'ve lived in for years — or decades — is real. And most agents don\'t know how to handle it with the care it deserves.',
  clarityPoints: [
    'Private, off-market options so your transition stays between you and your family.',
    'Cash offers with flexible timelines — close in 10 days or take the time you need.',
    'Full concierge moving coordination: packing, storage, and logistics handled from escrow.',
    'No-cost renovation option if maximizing equity is the priority.',
    'A process designed for sensitivity — no open houses, no strangers walking through your memories.',
  ],
  calm:
    'This isn\'t about giving something up.\nIt\'s about making room for what matters most right now.\n\nYour report shows every option clearly — so you can decide from a place of strength, not stress.',
  ctaText: 'See My Options Privately',
  pullQuote: 'There exists a category of homeowners navigating change quietly. We exist for them.',
  utmSource: 'sell-health',
};

export default function SellHealthPage() {
  return <LandingPage content={content} />;
}
